var _ellipse, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEmptySearch = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6655,
    cy: 17.7553,
    rx: 14.332,
    ry: 14.4221,
    fill: "#D3DCE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.458 36.5921C33.9013 36.574 33.3719 36.345 32.9759 35.9507L29.5819 31.9836C28.8542 31.3181 28.7947 30.1872 29.4485 29.4481C29.7545 29.1385 30.1706 28.9644 30.6045 28.9644C31.0385 28.9644 31.4546 29.1385 31.7606 29.4481L36.0291 32.8635C36.6439 33.4928 36.8337 34.427 36.5135 35.2486C36.1933 36.0703 35.423 36.6257 34.547 36.6666L34.458 36.5921Z",
    fill: "#D3DCE6"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptySearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/empty-search.52982161.svg";
export { ForwardRef as ReactComponent };